import React from "react";
import { Effect, identity, pipe } from "effect";
export const createRuntimeContext = (layer)=>{
    const context = React.createContext(undefined);
    return Object.assign(context, {
        layer
    });
};
export const fromLayer = (layer, cb = identity)=>pipe(layer, Effect.andThen(cb));
